import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { SharedService } from '../../services/sharedservice/shared.service.service';

export const PermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const sharedService = inject(SharedService);
  const router = inject(Router);
  
  const requiredSlug = route.data?.['slug'];    
  if (requiredSlug && sharedService.hasPermission(requiredSlug)) {
    return true;
  }

  return router.parseUrl('/home');
};